import React from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

function ContractPreview({ formData }) {
  const generatePDF = () => {
    const input = document.getElementById("contract");
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4"
      });

      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      const margin = 10; // 10 mm margin
      pdf.addImage(imgData, "PNG", margin, margin, pdfWidth - 2 * margin, pdfHeight - 2 * margin);
      pdf.save(`${formData.contractNumber}.pdf`);
    });
  };

  return (
    <div className="p-6 border border-gray-400 rounded-md shadow-lg">
      <div id="contract" className="container border-t-4 border-red-500" style={{ padding: "20px" }}>
        <div className="flex flex-row justify-between my-6 p-8">
          <div className="flex">
            <img
              src="image/gears.png"
              className="h-20 w-20"
              alt="logo"
            />
            <div className="ml-4">
              <p style={{ fontSize: "24px", fontWeight: "bold", marginBottom: "8px" }}>
                IT Consultancy Services Agreement
              </p>
              <p style={{ fontSize: "20px", fontWeight: "bold" }}>
                #{formData.contractNumber}
              </p>
            </div>
          </div>
          <div className="text-right" style={{ color: "#4a4a4a" }}>
            <p style={{ fontSize: "18px", fontWeight: "bold", color: "#333" }}>
              {formData.serviceProviderName}
            </p>
            <p>{formData.serviceProviderAddress}</p>
            <p>{formData.serviceProviderEmail}</p>
            <p style={{ fontSize: "18px", fontWeight: "bold", color: "#333", marginTop: "16px" }}>
              {formData.customerName}
            </p>
            <p>{formData.customerAddress}</p>
            <p>{formData.customerEmail}</p>
          </div>
        </div>
        <hr />
        <div className="my-4">
          <p>
            <strong>RECITALS:</strong>
          </p>
          <p>
            This IT Consultancy Services Agreement (“Agreement”) is made on this{" "}
            <span style={{ fontWeight: "bold", fontStyle: "italic" }}>{formData.effectiveDate}</span>,
            by and between{" "}
            <span style={{ fontWeight: "bold" }}>{formData.serviceProviderName}</span>{" "}
            (“Service Provider”) having its registered office at{" "}
            <span style={{ fontWeight: "bold" }}>{formData.serviceProviderAddress}</span>
            , represented by{" "}
            <span style={{ fontWeight: "bold" }}>
              {formData.serviceProviderRepresentativeName}
            </span>
            , who is the{" "}
            <span style={{ fontWeight: "bold" }}>
              {formData.customerRepresentativeTitle}
            </span>
            , and <span style={{ fontWeight: "bold" }}>{formData.customerName}</span>{" "}
            (“Customer”) having its registered office at{" "}
            {formData.customerAddress}, represented by{" "}
            <span style={{ fontWeight: "bold" }}>
              {formData.customerRepresentativeName}, <span style={{ fontWeight: "bold" }}>{formData.customerRepresentativeTitle}</span>
            </span>
            .
          </p>
          <p>
            WHEREAS, the Service Provider specializes in providing IT
            consultancy services; and
          </p>
          <p>
            WHEREAS, the Customer desires to engage the Service Provider to
            provide IT infrastructure upgrade services;
          </p>
        </div>
        <hr />
        <div className="my-4">
          <p>
            <strong>OPERATIVE TERMS:</strong>
          </p>
          <p>
            <strong>1. SERVICES AND CONSIDERATION:</strong>
          </p>
          <p>
            1.1 The Service Provider shall provide the following services to the
            Customer:
          </p>
          <ul className="list-disc list-inside">
            <li>
              IT infrastructure upgrade consulting and implementation services.
            </li>
            <li>Training of customer staff on new systems.</li>
          </ul>
          <p>
            1.2 The Customer agrees to pay the Service Provider the total amount
            of ${formData.totalAmount} for the services rendered, payable within
            30 days of the invoice date according to the{" "}
            <a href="#paymentterms">Payment Terms</a> outlined in Section 5.
          </p>
          <p>
            <strong>2. TERM:</strong>
          </p>
          <p>
            This Agreement shall begin on the Effective Date and remain in force
            until completion of the services or upon termination as allowed by
            Section 9.
          </p>
          <p>
            <strong>3. RESPONSIBILITIES:</strong>
          </p>
          <p>
            3.1 The Service Provider shall assign qualified professionals to
            carry out the tasks mentioned in Section 1.1 and follow best
            practices throughout the engagement.
          </p>
          <p>
            3.2 The Customer shall provide access to necessary facilities,
            systems, and documentation to facilitate efficient execution of the
            project.
          </p>
        </div>
        <div id="paymentterms" className="my-4">
          <p>
            <strong>5. PAYMENT TERMS:</strong>
          </p>
          <p>
            5.1 Payment for the services rendered shall be made within thirty
            (30) calendar days of receiving the corresponding invoice.
          </p>
          <p>
            5.2 All payments shall be processed in USD ($) via wire transfer to
            the account details provided in writing by the Service Provider.
          </p>
          <p>
            5.3 Late payments shall accrue interest at a rate equal to three
            percent (3%) per month or the highest rate allowed by applicable
            laws.
          </p>
        </div>
        <div className="my-4">
          <p>
            <strong>6. CONFIDENTIALITY:</strong>
          </p>
          <p>
            6.1 Both Parties acknowledge that they may receive proprietary and
            confidential information during the course of this engagement. Each
            Party shall treat all confidential information received from the
            other Party as strictly confidential and restrict its dissemination
            to individuals requiring knowledge for fulfilling their duties under
            this Agreement.
          </p>
        </div>
        <div className="my-4">
          <p>
            <strong>7. LIMITATION OF LIABILITY:</strong>
          </p>
          <p>
            7.1 Neither Party shall be liable to the other for indirect,
            incidental, consequential, exemplary, punitive, or special damages
            resulting from this Agreement even if advised of the possibility of
            such damages.
          </p>
        </div>
        <div className="my-4">
          <p>
            <strong>8. FORCE MAJEURE:</strong>
          </p>
          <p>
            8.1 Neither Party shall be liable for any delay or failure to
            perform its obligations under this Agreement due to events beyond
            its control, including natural disasters, acts of terrorism,
            strikes, government orders, labor shortages, pandemics, or failures
            of suppliers or carriers, provided prompt written notice of the
            cause of such delay or failure is given.
          </p>
        </div>
        <div className="my-4">
          <p>
            <strong>9. TERMINATION:</strong>
          </p>
          <p>
            9.1 Either Party may terminate this Agreement immediately upon
            giving written notice if:
          </p>
          <ul className="list-disc list-inside">
            <li>
              The other Party commits a material breach of this Agreement and
              fails to cure such breach within ten (10) days after receiving
              written notice describing the nature of the breach.
            </li>
            <li>
              The other Party becomes insolvent or files bankruptcy proceedings.
            </li>
          </ul>
        </div>
        <div className="my-4">
          <p>
            <strong>10. DISPUTE RESOLUTION:</strong>
          </p>
          <p>
            10.1 Any dispute or controversy arising out of or relating to this
            Agreement shall be resolved by binding arbitration in accordance
            with the rules of the American Arbitration Association.
          </p>
        </div>
        <div className="my-4">
          <p>
            <strong>11. ENTIRE AGREEMENT:</strong>
          </p>
          <p>
            11.1 This Agreement constitutes the entire understanding between the
            Parties and supersedes all prior oral or written communications
            concerning the subject matter of this Agreement.
          </p>
        </div>
        <div className="my-4">
          <p>
            <strong>12. COUNTERPARTS:</strong>
          </p>
          <p>
            12.1 This Agreement may be signed in counterparts, each of which
            shall be deemed an original, but all of which together shall
            constitute one instrument.
          </p>
        </div>
        <div className="mt-10">
          <p>
            <strong>IN WITNESS WHEREOF,</strong> the parties hereto have
            executed this Contract as of the date first above written.
          </p>
          <div className="flex flex-row justify-between mt-6">
            <div className="text-center">
              <p className="font-bold" style={{ fontSize: "20px" }}>
                {formData.serviceProviderName}
              </p>
              <p className="text-gray-500 italic" style={{ fontSize: "16px" }}>
                Authorized Signatory
              </p>
              <p className="underline" style={{ fontSize: "18px" }}></p>
              <p className="text-gray-500" style={{ fontSize: "16px" }}>
                {formData.serviceProviderRepresentativeName}
              </p>
              <p className="text-gray-500" style={{ fontSize: "16px" }}>
                {formData.serviceProviderRepresentativeTitle}
              </p>
            </div>
            <div className="text-center">
              <p className="font-bold" style={{ fontSize: "20px" }}>
                {formData.customerName}
              </p>
              <p className="text-gray-500 italic" style={{ fontSize: "16px" }}>
                Authorized Signatory
              </p>
              <p className="underline" style={{ fontSize: "18px" }}></p>
              <p className="text-gray-500" style={{ fontSize: "16px" }}>
                {formData.customerRepresentativeName}
              </p>
              <p className="text-gray-500" style={{ fontSize: "16px" }}>
                {formData.customerRepresentativeTitle}
              </p>
            </div>
          </div>
        </div>
      </div>
      <button
        type="button"
        onClick={generatePDF}
        className="mt-4 p-2 bg-blue-500 text-white rounded"
      >
        Download Contract PDF
      </button>
    </div>
  );
}

export default ContractPreview;
